<template>
  <b-modal id="folio-modal" :title="$t('menu.folio', 'Folio')" size="lg" ok-only>
    <b-tabs content-class="mt-3">
      <!-- Вкладка ENC S-63 (данные поставщика Primar - ячейки карт S63 ENC) -->
      <b-tab title="ENC S-63">
        <template v-if="s63Items.length">
          <b-table size="sm" :items="s63Items" :fields="folioFields" small striped class="folio-table" :sort-by="'createdUtc'" :sort-desc="true">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 's63 maps')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 's63 maps')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No ENC S-63 data purchased</p>
          </div>
        </template>
      </b-tab>

      <!-- Вкладка ENC S-102 (данные поставщика Primar - карты S102) -->
      <b-tab title="ENC S-102">
        <template v-if="s102Items.length">
          <b-table size="sm" :items="s102Items" :fields="folioFields" small striped class="folio-table" :sort-by="'createdUtc'" :sort-desc="true">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 's102 maps')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 's102 maps')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No ENC S-102 data purchased</p>
          </div>
        </template>
      </b-tab>

      <!-- Вкладка AVCS S-63 (данные поставщика UKHO/MSS - ячейки карт AVCS) -->
      <!-- <b-tab title="AVCS S-63">
        <template v-if="avcsItems.length">
          <b-table size="sm" :items="avcsItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'AVCS maps')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'AVCS maps')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No AVCS S-63 data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка ADP (данные поставщика UKHO/MSS - публикации ADP) -->
      <!-- <b-tab title="ADP">
        <template v-if="adpItems.length">
          <b-table size="sm" :items="adpItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'ADP')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'ADP')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No ADP data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка eNP (данные поставщика UKHO/MSS - публикации eNP) -->
      <!-- <b-tab title="eNP">
        <template v-if="enpItems.length">
          <b-table size="sm" :items="enpItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'ENP')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'ENP')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No eNP data purchased</p>
          </div>
        </template>
      </b-tab> -->

      <!-- Вкладка Navarea (данные поставщика UKHO/MSS - навигационные предупреждения по районам) -->
      <b-tab title="Navarea">
        <template v-if="navareaItems.length">
          <b-table size="sm" :items="navareaItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'Navarea')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'Navarea')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No Navarea data purchased</p>
          </div>
        </template>
      </b-tab>

      <!-- Вкладка AIO (данные поставщика UKHO/MSS - данные Admirality Overlay Information) -->
      <!-- <b-tab title="AIO">
        <template v-if="aioItems.length">
          <b-table size="sm" :items="aioItems" :fields="folioFields" small striped class="folio-table">
            <template #cell(createdUtc)="data">
              {{ formatDate(data.value) }}
            </template>
            <template #cell(items)="data">
              <div v-for="item in getFilteredItems(data.value, 'AIO')" :key="item.id">{{ item.id }} ({{ item.monthCount }} months)</div>
            </template>
            <template #cell(daysLeft)="row">
              <div v-for="item in row.item.items.filter(item => item.type === 'AIO')" :key="item.id">
                <span v-if="item.monthCount > 0" :class="getDaysLeftClass(row.item.createdUtc, item.monthCount)">
                  {{ calculateDaysLeft(row.item.createdUtc, item.monthCount) }} days
                </span>
              </div>
            </template>
          </b-table>
        </template>
        <template v-else>
          <div class="text-center py-4">
            <p class="text-muted">No AIO data purchased</p>
          </div>
        </template>
      </b-tab> -->
      
    </b-tabs>
  </b-modal>
</template>

<script>
export default {
  props: {
    folio: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      folioFields: [
        { key: 'items', label: 'Items', tdClass: 'text-left' },
        { key: 'paymentMethod', label: 'Payment Method', tdClass: 'text-left' },
        { key: 'createdUtc', label: 'Date', tdClass: 'text-left', sortable: true },
        { key: 'daysLeft', label: 'Days left', tdClass: 'text-left' },
      ],
    }
  },

  computed: {
    // Получение ячеек карт в формате S63 ENC от Primar
    s63Items() {
      return this.getItemsByType('s63 maps')
    },

    // Получение ячеек карт в формате S102 ENC
    s102Items() {
      return this.getItemsByType('s102 maps')
    },

    // Получение ячеек карт в формате AVCS от UKHO/MSS
    avcsItems() {
      return this.getItemsByType('AVCS maps')
    },

    // Получение публикаций ADP от UKHO/MSS
    adpItems() {
      return this.getItemsByType('ADP')
    },

    // Получение публикаций eNP от UKHO/MSS
    enpItems() {
      return this.getItemsByType('ENP')
    },

    // Получение данных Navarea (навигационные предупреждения по районам)
    navareaItems() {
      return this.getItemsByType('Navarea')
    },

    // Получение данных AIO (All In One)
    aioItems() {
      return this.getItemsByType('AIO')
    },
  },
  methods: {
    // Получение элементов по типу
    getItemsByType(itemType) {
      return this.folio.filter(folioItem => {
        return folioItem.items && folioItem.items.some(item => item.type === itemType)
      })
    },

    // Фильтрация элементов по типу
    getFilteredItems(items, itemType) {
      if (!items) return []
      return items.filter(item => item.type === itemType)
    },

    // Форматирование даты в удобочитаемый формат
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      return date.toLocaleString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
      })
    },

    // Расчет оставшихся дней до окончания действия подписки
    calculateDaysLeft(startDate, monthCount) {
      if (!startDate || !monthCount || monthCount <= 0) return 0

      const start = new Date(startDate)
      const end = new Date(start)
      end.setMonth(end.getMonth() + monthCount)

      const now = new Date()
      const daysLeft = Math.floor((end - now) / (1000 * 60 * 60 * 24))

      return daysLeft > 0 ? daysLeft : 0
    },

    // Получение CSS класса для отображения оставшихся дней
    getDaysLeftClass(startDate, monthCount) {
      if (!startDate || !monthCount || monthCount <= 0) return ''

      const daysLeft = this.calculateDaysLeft(startDate, monthCount)

      if (daysLeft < 1) return 'days-critical'
      if (daysLeft <= 30) return 'days-warning'
      return 'days-good'
    },
  },
}
</script>

<style scoped>
.folio-table .date-column {
  width: 150px;
  min-width: 150px;
  max-width: 150px;
}

.days-good {
  background-color: #24ee24;
  padding: 2px 6px;
  border-radius: 4px;
}

.days-warning {
  background-color: #fff3cd;
  padding: 2px 6px;
  border-radius: 4px;
}

.days-critical {
  background-color: #f8d7da;
  padding: 2px 6px;
  border-radius: 4px;
}
</style>
